import * as React from "react";
import { ChangeEvent, PureComponent } from "react";

interface TextFieldProps {
  value?: string;
  maxLength?: number;
  errorMessage?: string;
  onChange: (string: string) => void;
}

export default class TextField extends PureComponent<TextFieldProps> {
  render() {
    const extraProps: any = {};
    if (this.props.maxLength > 1) {
      extraProps.maxLength = this.props.maxLength;
    }
    return (
      <div className={"text-field" + (this.props.errorMessage ? " invalid" : "")}>
        <input
          type="text"
          value={TextField.nullToEmpty(this.props.value)}
          onChange={this.onChange}
          {...extraProps}
        />
        <div className="input-accessories">
          <div className="error-message">{this.props.errorMessage}</div>
        </div>
      </div>
    );
  }

  private onChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(TextField.emptyToNull(e.target.value));
  };

  private static nullToEmpty(value: string): string {
    return value == null ? "" : value;
  }

  private static emptyToNull(value: string): string {
    return value == "" ? null : value;
  }
}
